import { render, staticRenderFns } from "./ResourceBlock.vue?vue&type=template&id=5cf55b7a&scoped=true&"
import script from "./ResourceBlock.vue?vue&type=script&lang=js&"
export * from "./ResourceBlock.vue?vue&type=script&lang=js&"
import style0 from "./ResourceBlock.vue?vue&type=style&index=0&id=5cf55b7a&scoped=true&lang=css&"
import style1 from "./ResourceBlock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf55b7a",
  null
  
)

export default component.exports